import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function SCWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1873">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1874">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1875">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1876">
            WHAT IS SCULPTRA?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1877"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-1878">
            Sculptra is an injectable cosmetic filler designed to rejuvenate the
            face and combat signs of aging. It's formulated with poly-L-lactic
            acid (PLLA), a substance that's both biocompatible and
            biodegradable.
          </p>

          {/* Pull Quote */}
          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-1879">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-1880">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-1881">
              Sculptra is a game-changer for those seeking a natural, gradual
              enhancement. It's like rewinding time by encouraging your skin to
              rebuild its strength and volume from within. If you're looking for
              subtle, long-lasting results that let your beauty shine, Sculptra
              is your answer.
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-1882">
            <p data-id="element-1883">
              Unlike many other dermal fillers, Sculptra doesn't deliver instant
              results; instead, it kickstarts the body's natural collagen
              production process over time.
            </p>
            <p data-id="element-1884">
              Sculptra is especially suited for individuals looking for subtle,
              gradual improvements that enhance their natural appearance. It's
              commonly used to address volume loss in areas like the cheeks,
              temples, and jawline, offering a non-invasive solution to restore
              youthful contours without surgery. This makes it a popular choice
              for those seeking a long-lasting, natural-looking enhancement.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}